import { getJson, patchJson, postJson } from "../../core/http";

export function createPrediction(payload) {
  return postJson("/api/v1/predictions", payload);
}

export function fetchPredictionById(predictionId) {
  return getJson(`/api/v1/predictions/${encodeURIComponent(String(predictionId))}`);
}

/** Shallow-allowed keys are enforced server-side; merges into existing result_payload. */
export function mergePredictionResultSnapshot(predictionId, resultPayloadMerge) {
  return patchJson(`/api/v1/predictions/${encodeURIComponent(String(predictionId))}`, {
    result_payload: resultPayloadMerge || {},
  });
}

export function createWesternGeneratePrediction(payload) {
  return createPrediction({
    ...payload,
    feature: "western",
  });
}

export function createChineseGeneratePrediction(payload) {
  return createPrediction({
    ...payload,
    feature: "chinese",
  });
}

export function createTarotGeneratePrediction(payload) {
  return createPrediction({
    ...payload,
    feature: "tarot",
  });
}

export function createWeddingGeneratePrediction(payload) {
  return createPrediction({
    ...payload,
    feature: "wedding",
  });
}

export function createCoupleMatchGeneratePrediction(payload) {
  return createPrediction({
    ...payload,
    feature: "couple_match",
  });
}

export function scoreWeddingCompatibility(payload) {
  return postJson("/api/v1/wedding/score", payload);
}
